import { UserClient } from '../types'

export const deleteAvatar = (base: UserClient) => () =>
  base.requester.delete('/avatar', { withCredentials: true })
